const CONSTANTS = require('../../lib/constants');
const utils     = require('../../lib/utils');

module.exports = {
	config: {
		closableTabs: true,
		focusAble:    true,
		environmentDependent: true,
		flexHeight: false,
		startWithRegisterSecret: '',
		maxWidthTabs: false
	},

	actions: {
		addTab: {
			type: CONSTANTS.COMPONENT.ACTION.TYPE.LOAD,
			source: {
				load: {
					componentData: {
						component: [
							'base',
							'tabStrip',
							'tab'
						]
					}
				}
			},
			target: {
				element: CONSTANTS.COMPONENT.ACTION.TARGET.ELEMENT.SELF,
				position: CONSTANTS.COMPONENT.ACTION.TARGET.POSITION.APPEND
			}
		},
		addTabContent: {
			type: CONSTANTS.COMPONENT.ACTION.TYPE.LOAD,
			source: {
				load: {
					componentData: {
						type: 'component',
						subType: 'layout',
						component: [
							'base',
							'tabStrip',
							'tabContent'
						],
						children: [
							{
								type: "section",
								subType: null,
								code: "content",
								privilegeCode: null,
								children: [

								]
							}
						]
					}
				}
			},
			target: {
				element: CONSTANTS.COMPONENT.ACTION.TARGET.ELEMENT.SELF,
				position: CONSTANTS.COMPONENT.ACTION.TARGET.POSITION.APPEND
			}
		}
	},

	events: {
		/**
		 * this function handles the Escape and Enter key-down-events
		 */
		keyboard: {
			type: 'keydown',
			action: function(event){
				switch(utils.keyboard.getKeyCode(event)){
					case 'esc':
						var registerSecret, registerEntry, tabComponent;
						if(
							(registerSecret = event.data.component.model.activeRegisterSecret) !== undefined &&
							(registerEntry = event.data.component.registry[registerSecret]) &&
							(tabComponent = registerEntry.tab) &&
							tabComponent.config.closable
						){
							event.data.component.removeTab(registerSecret);
						}
						break;
				}
			}
		}
	},

	model: {
		activeRegisterSecret: '',
		actualNrOfDynamicTabs: 0
	},

	methods: {


		/**
		 * this function calculates the widths of the tabs and appends a class to the tabStrip if sum of tab-widths is bigger then the tabStrip's width
		 */
		calculateTabStripDisplayType: function(){
			var tabComponent;
			if (
				(tabComponent = ((this.registry || [])[0] || {}).tab)
				&&
				(tabComponent.$ || []).length > 0
			){
				var tabItemHeight = Math.ceil(this.registry[0].tab.$.outerHeight(true));
				var $tabSection = this.$.find("> section.tabs");

				// set class "detachedTabs" if sum of tab-withs is bigger then width of tab-strip
				if((2 * tabItemHeight) < $tabSection.outerHeight(true)){
					if(!this.$.hasClass('detachedTabs')){
						this.$.addClass('detachedTabs');
					}
				} else {
					if(this.$.hasClass('detachedTabs')) {
						this.$.removeClass('detachedTabs');
					}
				}
			}
		},

		/**
		 * environment has been updated (resize)
		 */
		onEnvironmentUpdated: function(){
			this.calculateTabStripDisplayType();
		},

		/**
		 * this function is used to perform the needed load actions for a tab and a tabContent extended by selective data from the original tabAction given.
		 *
		 * @param   data                                    mixed - PromiseContext of tab-action
		 * @param   originalActionParentComponentIndex      int - component index of the component which performs the addTab action.
		 * @returns int                                     registerSecret of the new tab
		 */
		addTab: function(data, originalActionParentComponentIndex){
			// init
			var self = this;
			var nextRegisterSecret = this.model.actualNrOfDynamicTabs++;

			// define tab content component
			var contentComponent;
			var contentChildren = [];
			if(data.action.source.tabContent.component){
				contentComponent = data.action.source.tabContent.component;
			}
			else if(data.action.source.tabContent.routePath){
				contentComponent = data.action.source.tabContent.componentTree.children[data.action.source.tabContent.componentTree.childLayoutIndex];
			}
			if(contentComponent){
				if(originalActionParentComponentIndex != undefined){
					contentComponent.originalActionParentComponentIndex = originalActionParentComponentIndex;
				}
				contentChildren[0] = contentComponent;
			}

			// load tab
			return utils.promise.performAll(this, [
				this.performAndStoreAction(
					undefined,
					this.prepareAction(
						'addTab',
						undefined,
						undefined,
						{
							source: {
								load: {
									componentData: utils.merge(
										data.action.source.tab.componentData,
										{
											config: {
												registerSecret: nextRegisterSecret,
												closable:      self.config.closableTabs
											}
										}
									),
									resourceRegister:       data.action.source.tab.resourceRegister,
									resourceRegisterKey:    data.action.source.tab.resourceRegisterKey
								}
							}
						}
					)
				),
				this.performAndStoreAction(
					undefined,
					this.prepareAction(
						'addTabContent',
						undefined,
						undefined,
						{
							source: {
								load: {
									componentData: {
										children: [
											{
												children: contentChildren
											}
										],
										config: {
											registerSecret: nextRegisterSecret
										}
									},
									resourceRegister:       data.action.source.tabContent.resourceRegister,
									resourceRegisterKey:    data.action.source.tabContent.resourceRegisterKey
								}
							}
						}
					)
				)
			]).then(function(data){
				// save tab connection
				data.action.tabConnection = {
					tabStripComponentIndex: self.componentIndex,
					tabRegisterSecret: nextRegisterSecret
				};

				// focus new tab
				self.focusTab(nextRegisterSecret);

				// re-calculate tab-strip
				self.calculateTabStripDisplayType();

				// return promise data
				return utils.promise.resolve(data);
			}).fail(function(error){
				this.action.tabConnection = {
					tabStripComponentIndex: self.componentIndex,
					tabRegisterSecret: nextRegisterSecret
				};

				// cleanup dynamic action components and its' actions in case of an error
				utils.forEach(self.actions, function(action, actionKey){
					if(
						action.source.load &&
						action.source.load.component &&
						action.source.load.component.config.registerSecret != undefined &&
						action.source.load.component.config.registerType != undefined &&
						(
							!self.registry[action.source.load.component.config.registerSecret] ||
							!self.registry[action.source.load.component.config.registerSecret][action.source.load.component.config.registerType]
						)
					){
						action.source.load.component.destroy();
					}
				});

				return utils.promise.reject(this);
			});
		},

		/**
		 * this function is used to destroy a tab inclusive its' contents completely
		 *
		 * @param registerSecret
		 */
		removeTab: function(registerSecret, restoreActiveTab = false){
			// for deactivation issues focus tab before actual tab destruction.
			var registryKeys = Object.keys(this.registry);
			var restoreRegisterSecret;
			if(restoreActiveTab){
				restoreRegisterSecret = this.model.activeRegisterSecret;
			}

			if(registryKeys.length > 0){
				if(registerSecret == this.model.activeRegisterSecret || this.model.activeRegisterSecret == ''){
					registryKeys = this.getSortedRegisterSecrets();
					var lastRegistryKey = registryKeys.pop();
					if(lastRegistryKey == registerSecret){
						if(registryKeys.length > 0){
							lastRegistryKey = registryKeys.pop();
						}
						else {
							if(this.registry[lastRegistryKey].tab)          this.registry[lastRegistryKey].tab.deactivate(true);
							if(this.registry[lastRegistryKey].tabContent)   this.registry[lastRegistryKey].tabContent.deactivate(true);
							lastRegistryKey = undefined;
						}
					}
					if(lastRegistryKey != undefined) this.focusTab(restoreRegisterSecret !== undefined ? restoreRegisterSecret : lastRegistryKey);
				}
				else {
					this.focusTab(this.model.activeRegisterSecret, true);
				}
			}

			// destroy tab which should be removed
			if(registerSecret != undefined && this.registry[registerSecret]){
				// NOTE:    the Component.prototype.destroy() method is able to remove parents' registry entries if they are empty.
				//          so this doubled proofing of the registry entry is necessary sometimes.
				//          (e.g., in case of an action rollback because of an error during tab content load)
				if(this.registry[registerSecret] && this.registry[registerSecret].tab)           this.registry[registerSecret].tab.remove();
				if(this.registry[registerSecret] && this.registry[registerSecret].tabContent)    this.registry[registerSecret].tabContent.remove();
			}

			// re-calculate tab-strip
			this.calculateTabStripDisplayType();
		},

		/**
		 * hide a tab-head identified by registerSecret.
		 *
		 * @param   registerSecret        int - registerSecret
		 */
		hideTab: function(registerSecret){
			var components = (this.registry || {})[registerSecret];
			if(components){
				components.tab.$.css({
					width: 0,
					height: 0,
					padding: 0,
					margin: 0,
					'border-width': 0,
					opacity: 0,
					overflow: 'hidden'
				});
			}
		},

		/**
		 * this function is used to focus a tab identified by the given registerSecret.
		 *
		 * @param   registerSecret        int - registerSecret
		 * @param   forceHandlers         boolean - should the handler execution be forced?
		 * @returns boolean - success (may be false if tab not found according to given registerSecret)
		 */
		focusTab: function(registerSecret, forceHandlers){
			this.model.activeRegisterSecret = registerSecret;
			var self = this;

			utils.forEach(this.registry, function(registerElement, registerElementSecret){
				if(registerSecret != registerElementSecret){
					if(registerElement.tab) registerElement.tab.deactivate(forceHandlers);
					if(registerElement.tabContent) registerElement.tabContent.deactivate(forceHandlers);
				}
			});

			if(registerSecret != undefined && this.registry[registerSecret]){
				if(this.registry[registerSecret].tab)           this.registry[registerSecret].tab.activate(forceHandlers);
				if(this.registry[registerSecret].tabContent)    this.registry[registerSecret].tabContent.activate(forceHandlers);

				// when a tab will be displayed bold after activation the with needed can change.
				this.calculateTabStripDisplayType();
				return true;
			}

			return false;
		},

		/**
		 * this function is used to focus the next available tab in the actual tab list
		 * NOTE: if the last tab is the actual one, the first tab will be focused.
		 */
		focusNextTab: function(){
			var tabSecrets, activationTabRegisterSecret;
			if(this.model.activeRegisterSecret == undefined){
				tabSecrets = Object.keys[this.registry];
				if(tabSecrets.length > 0) activationTabRegisterSecret = tabSecrets.shift();
			}
			else {
				tabSecrets = Object.keys[this.registry];
				var nextTabSecretIndex = tabSecrets.indexOf(this.model.activeRegisterSecret) + 1;
				if(tabSecrets.length > nextTabSecretIndex && nextTabSecretIndex >= 0) activationTabRegisterSecret = tabSecrets[nextTabSecretIndex];
			}

			if(activationTabRegisterSecret != undefined) this.focusTab(activationTabRegisterSecret);
		},

		/**
		 * this function is used to focus the previous available tab in the actual tab list.
		 * NOTE: if the first tab is the actual one, the last tab will be focused.
		 */
		focusPreviousTab: function(){
			var tabSecrets, activationTabRegisterSecret;
			if(this.model.activeRegisterSecret == undefined){
				tabSecrets = Object.keys[this.registry];
				if(tabSecrets.length > 0) activationTabRegisterSecret = tabSecrets.pop();
			}
			else {
				tabSecrets = Object.keys[this.registry];
				var nextTabSecretIndex = tabSecrets.indexOf(this.model.activeRegisterSecret) - 1;
				if(tabSecrets.length > nextTabSecretIndex && nextTabSecretIndex >= 0) activationTabRegisterSecret = tabSecrets[nextTabSecretIndex];
			}

			if(activationTabRegisterSecret != undefined) this.focusTab(activationTabRegisterSecret);
		},

		/**
		 * this function is used to mark a tab with the given type.
		 *
		 * @param registerSecret		mixed - register secret of tab which should be marked
		 * @param type					string - mark type (at the moment: "validationError" | <empty string>)
		 */
		markTab: function(registerSecret, type){
			var tabComponent;
			if(type !== undefined && registerSecret !== undefined && this.registry[registerSecret] && (tabComponent = this.registry[registerSecret].tab)){
				tabComponent.mark(type);
			}
		},

		/**
		 * this function refreshes a tab and a tabContent component identified by the registerSecret and replaces the tabOptions within the tab-Component if necessary.
		 *
		 * @param registerSecret		int - register secret identifying the tab
		 * @param tabOptions			{} - optional - tabOptions used for tab head refresh
		 * @param refreshTabContent		boolean - default: false - should the tabContent component be refreshed too?
		 */
		refreshTab: function(registerSecret, tabOptions, refreshTabContent){
			var components = (this.registry || {})[registerSecret];
			if(components){
				utils.refReplace(components.tab.resourceData, tabOptions || {});
				components.tab.refresh();
				if(refreshTabContent) components.tabContent.refresh();
			}
		},

		/**
		 * this function returns a tabComponent or a tabContentComponent according to the given params if possible.
		 *
		 * @param registerSecret 	int - register secret identifying the tab
		 * @param getTab			boolean - default: false - should the tabContent- or tab- component be returned
		 * @returns Component-Instance || false
		 */
		getTabComponent: function(registerSecret, getTab){
			var components = (this.registry || {})[registerSecret || -1];
			if(components){
				if(getTab) return components.tab;
				return components.tabContent;
			}
			return false
		},

		/**
		 * this function returns an array containing register secrets naturally ordered.
		 *
		 * @returns {Array.<*>}
		 */
		getSortedRegisterSecrets: function(){
			var staticRegisterSecrets = Object.keys(this.registry);
			var dynamicRegisterSecrets = [];
			var staticRegisterSecretIndex;
			utils.forEach(this.actions, function(action){
				if(action.tabConnection && action.tabConnection.tabRegisterSecret != undefined){
					dynamicRegisterSecrets.push(action.tabConnection.tabRegisterSecret);
					staticRegisterSecretIndex = utils.indexOf(staticRegisterSecrets, action.tabConnection.tabRegisterSecret);
					if(staticRegisterSecretIndex >= 0) staticRegisterSecrets.splice(staticRegisterSecretIndex, 1);
				}
			});

			return staticRegisterSecrets.concat(dynamicRegisterSecrets);
		}
	},

	hooks: {
		attach: function($element, options){
			if(utils.collectionSize(this.registry) > 0){
				if(options.refresh){
					this.focusTab(this.model.activeRegisterSecret, true);
				}
				else if(this.config.startWithRegisterSecret) {
					this.focusTab(this.config.startWithRegisterSecret, true);
				}
				else {
					this.focusTab(Object.keys(this.registry)[0], true);
				}
			}
		}
	}
};